<template>
  <v-data-table
    :footer-props="{
      'items-per-page-text': 'Số dữ liệu mỗi trang',
      'items-per-page-options': [10, 20, 50]
    }"
    disable-sort
    :headers="headers"
    :items="tableInfo"
    :server-items-length="totalCount"
    :items-per-page="itemsPerPage"
    @update:page="val => updatePagination('page', val)"
    @update:items-per-page="val => updatePagination('itemsPerPage', val)"
    :loading="loading"
    :expanded.sync="expandedItems"
    ref="data-table"
    @click:row="item => handleRowClick(item)"
    hide-default-header
  >
    <template v-slot:header>
      <thead>
        <tr>
          <th
            v-for="header in headers"
            :key="header.value"
            :style="{
              width: header.width,
              'min-width': header.width,
              'text-align': header.align ? header.align : 'left'
            }"
          >
            <span v-if="header.formatText" v-html="header.formatText"></span>
            <span v-else>{{ header.text }}</span>
          </th>
        </tr>
      </thead>
    </template>
    <template v-slot:no-data>
      <div class="my-12 font-weight-bold">
        <p>Không có dữ liệu</p>
      </div>
    </template>
    <template v-slot:expanded-item="{ item }">
      <TableExpandReportOnTime :model="item" :descriptionColumn="descriptionColumnWidth" />
    </template>
    <template v-slot:[`body.prepend`]>
      <tr>
        <td colspan="1">
          <input
            class="pl-1 font-style"
            @keyup.enter="val => {}"
            placeholder="Nhập mã"
            v-model="filter.code_contains"
            style="border: 1px rgba(0, 0, 0, 0.38) solid; height: 28px; border-radius: 3px;::placeholder { color: #999999; }"
          />
        </td>
        <td colspan="1">
          <StatusSelect
            placeholder="Chọn trạng thái"
            :items="[
              { label: 'Kinh doanh', value: 'active' },
              { label: 'Bỏ mẫu', value: 'inactive' },
              { label: 'Đã bị xóa', value: 'deleted' }
            ]"
            @onChangeStatus="
              val => {
                filter.status = val
              }
            "
          />
        </td>
        <td colspan="1">
          <StatusSelect
            :style="{ width: '184px' }"
            placeholder="Chọn ưu thế"
            :items="[
              { label: 'Hàng phổ thông', value: 'typical' },
              { label: 'Độc quyền ưu thế', value: 'exclusiveAdvance' },
              { label: 'Độc quyền sỉ', value: 'exclusiveMass' },
              { label: 'Độc quyền toàn phần', value: 'exclusiveAll' }
            ]"
            @onChangeStatus="
              val => {
                filter.advantage = val
              }
            "
          />
        </td>
        <td colspan="1">
          <input
            class="pl-1 font-style"
            @keyup.enter="val => {}"
            placeholder="Nhập tên / mô tả"
            v-model="filter.description_contains"
          />
        </td>
        <td class="text-right red--text">{{ stats.totalInventoryQuantity | formatNumber }}</td>
        <td class="text-right red--text">{{ stats.totalSupplierStoreQuantity | formatNumber }}</td>
        <td class="text-right red--text">{{ stats.totalSystemStoreQuantity | formatNumber }}</td>
        <td class="text-right red--text" v-if="$auth.policies['import-report-on-times:view-system-store-price']">
          {{ stats.totalSystemStorePrice | formatNumber }}
        </td>
        <td class="text-right red--text">{{ stats.totalSupplierSample | formatNumber }}</td>
        <td class="text-right red--text">{{ stats.totalBadSkinQuantity | formatNumber }}</td>
        <td class="text-right red--text">{{ stats.totalDebtStoreQuantity | formatNumber }}</td>
        <td></td>
      </tr>
    </template>
    <template v-slot:[`item.description`]="{ item }">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <div v-on="on">
            <div class="text-ellipsis">{{ get(item, 'description', '--') }}</div>
          </div>
        </template>
        <span>{{ get(item, 'description', '') }}</span>
      </v-tooltip>
    </template>
    <template v-slot:[`item.totalInventoryQuantity`]="{ item }">
      {{ item.totalInventoryQuantity | formatNumber }}
    </template>
    <template v-slot:[`item.status`]="{ item }">
      {{ getStatus(item.status) }}
    </template>
    <template v-slot:[`item.advantage`]="{ item }">
      <AdvantageChip :status="item.advantage" />
    </template>
    <template v-slot:[`item.totalSupplierStoreQuantity`]="{ item }">
      {{ item.totalSupplierStoreQuantity | formatNumber }}
    </template>
    <template v-slot:[`item.totalSystemStoreQuantity`]="{ item }">
      {{ item.totalSystemStoreQuantity | formatNumber }}
    </template>
    <template v-slot:[`item.totalSystemStorePrice`]="{ item }">
      {{ item.totalSystemStorePrice | formatNumber }}
    </template>
    <template v-slot:[`item.totalBadSkinQuantity`]="{ item }">
      {{ item.totalBadSkinQuantity | formatNumber }}
    </template>
    <template v-slot:[`item.totalDebtStoreQuantity`]="{ item }">
      {{ item.totalDebtStoreQuantity | formatNumber }}
    </template>
    <template v-slot:[`item.code`]="{ item }">
      <router-link style="text-decoration: none" :to="'/'">
        <div style="white-space: nowrap">
          {{ item.code }}
        </div>
      </router-link>
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <div class="action-icons" v-if="item">
        <v-icon color="primary" size="20" class="cursor-pointer">
          mdi-eye
        </v-icon>
      </div>
    </template>
  </v-data-table>
</template>
<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import { debounce, get } from 'lodash'
import StatusSelect from '../../components/basic/StatusSelect.vue'
import TableExpandReportOnTime from './TableExpandReportOnTime.vue'
import AdvantageChip from '@/components/samnec/AdvantageChip.vue'
export default {
  props: {
    type: {
      type: String,
      enum: ['inventory', 'inventoryTime']
    }
  },
  components: { StatusSelect, TableExpandReportOnTime, AdvantageChip },
  mounted() {
    window.addEventListener('resize', this.setColumnWidths)
    this.setColumnWidths()
  },
  destroyed() {
    window.removeEventListener('resize', this.setColumnWidths)
  },
  data() {
    return {
      filter: {
        code_contains: '',
        status: '',
        advantage: '',
        description_contains: ''
      },
      outerParams: {},
      stats: {},
      expandedItems: [],
      descriptionColumnWidth: null,
      get
    }
  },
  computed: {
    ...mapState({
      tableInfo(state) {
        return state['reportOnTimes'].items
      },
      totalCount(state) {
        return state['reportOnTimes'].count
      },
      loading(state) {
        return state['reportOnTimes'].loading
      },
      searchQuery(state) {
        return state['reportOnTimes'].searchQuery
      },
      itemsPerPage(state) {
        return state['reportOnTimes'].itemsPerPage
      },
      headers(state) {
        let headers = state['constant'].ReportInTimeHeader.slice()
        if (!this.$auth.policies['import-report-on-times:view-system-store-price']) {
          const foundIndex = headers.findIndex(x => x.value === 'totalSystemStorePrice')
          headers.splice(foundIndex, 1)
        }
        return headers
      }
    })
  },
  methods: {
    ...mapActions({
      fetchReportOnTimes: 'reportOnTimes/fetchItems',
      countReportOnTimes: 'reportOnTimes/countItems',
      fetchStats: 'reportOnTimes/fetchStats'
    }),
    ...mapMutations({
      setQuerySearch: 'reportOnTimes/setQuerySearch',
      setItemsPerPage: 'reportOnTimes/setItemsPerPage',
      setLoading: 'reportOnTimes/setLoading'
    }),
    getStatus(status) {
      if (!status) return ''
      const enumStatus = {
        active: 'Kinh doanh',
        inactive: 'Bỏ mẫu',
        deleted: 'Đã bị xóa'
      }
      return enumStatus[status]
    },
    async updatePagination(type, val) {
      this.setLoading(true)
      const page = type === 'page' ? val : 1
      const itemsPerPage = type === 'itemsPerPage' ? val : this.itemsPerPage
      this.setItemsPerPage(itemsPerPage)
      await this.fetchReportOnTimes({
        _start: type === 'itemsPerPage' ? 0 : (page - 1) * itemsPerPage,
        _limit: itemsPerPage,
        ...this.searchQuery,
        ...this.filter
      })
      await this.countReportOnTimes({ ...this.searchQuery })
      setTimeout(() => {
        this.setLoading(false)
      }, 500)
    },
    async onRefresh({ params, isFetchStats = true }) {
      this.setLoading(true)
      await this.fetchReportOnTimes({
        _start: 0,
        _limit: this.itemsPerPage,
        ...params,
        ...this.filter
      })
      await this.countReportOnTimes(params)
      if (isFetchStats) {
        this.stats = await this.fetchStats({
          params: {
            ...params,
            ...this.filter
          }
        })
      }
      setTimeout(() => {
        this.setLoading(false)
      }, 500)
    },
    async onFilter(outerParams = {}) {
      const params = { ...this.filter, ...outerParams }
      if (Object.keys(outerParams).length) this.outerParams = outerParams
      await this.onRefresh({ params })
    },
    handleRowClick(item) {
      const isAction = event.target.closest('.icon-pencil')
      if (!isAction) {
        const index = this.expandedItems.findIndex(v => v.id === item.id)
        if (index === -1) this.expandedItems.push(item)
        else this.expandedItems.splice(index, 1)
      }
    },
    setColumnWidths() {
      const tableWidth = this.$refs['data-table'].$el.clientWidth
      const descriptionColumn = this.headers.find(header => header.value === 'description')
      if (descriptionColumn) {
        let desColWidth = 0
        let fixedWidth = 1180
        desColWidth = tableWidth - fixedWidth > 190 ? tableWidth - fixedWidth : 200
        this.descriptionColumnWidth = desColWidth
        descriptionColumn.width = `${desColWidth}px`
      }
    },
    debounce: debounce(async function() {
      await this.onFilter()
    }, 500)
  },
  async created() {
    await this.onRefresh({
      _limit: 10
    })
    this.setQuerySearch({})
  },
  watch: {
    filter: {
      handler(val) {
        if (val) {
          this.debounce()
        }
      },
      immediate: true,
      deep: true
    }
  }
}
</script>
<style scoped>
.text-red {
  color: red;
}
.text-right {
  text-align: right;
}

.font-style {
  border: 1px solid #00000061;
  height: 29px;
  border-radius: 4px;
  width: 100%;
  background-color: white;
  font-size: 16px;
  color: #23232361;
}
tr {
  cursor: pointer;
}
::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  padding: 0 8px;
}

::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  padding: 0 8px;
}
</style>
